import { render, staticRenderFns } from "./LiveStatsCard.vue?vue&type=template&id=50089c2d&scoped=true"
import script from "./LiveStatsCard.vue?vue&type=script&lang=js"
export * from "./LiveStatsCard.vue?vue&type=script&lang=js"
import style0 from "./LiveStatsCard.vue?vue&type=style&index=0&id=50089c2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50089c2d",
  null
  
)

export default component.exports